import { render, staticRenderFns } from "./answerListCustomers.vue?vue&type=template&id=06949fc7&scoped=true"
import script from "./answerListCustomers.vue?vue&type=script&lang=js"
export * from "./answerListCustomers.vue?vue&type=script&lang=js"
import style0 from "./answerListCustomers.vue?vue&type=style&index=0&id=06949fc7&prod&lang=scss&scoped=true"
import style1 from "./answerListCustomers.vue?vue&type=style&index=1&id=06949fc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06949fc7",
  null
  
)

export default component.exports